import _ from "lodash";
import { connect } from "react-redux";
import ReturnOrderItemsWindow from "../components/_ReturnOrderItemsWindow";
import * as actions from "../../../_actions/order";
import * as miscActions from "../../../_actions/misc";

const mapStateToProps = ({ OrderReturn, Misc }) => ({
    loading: OrderReturn.fetching.loading,
    err: OrderReturn.fetching.err,
    language: Misc.language.language,
    store: Misc.store.store,
    returnReasons: OrderReturn.Reasons.data || [],
    returnReasonsLoading: OrderReturn.Reasons.fetch.loading,
    returnReasonsLoadingError: OrderReturn.Reasons.fetch.err,
    returnOrderCalculateData: OrderReturn.Calculate.data,
    returnOrderCalculating: OrderReturn.Calculate.fetch.loading,
    returnOrderCalculatingError: OrderReturn.Calculate.fetch.err
});

const mapDispatchToProps = dispatch => ({
    returnOrder: (orderId, returnOrderData, language) => {
        dispatch(actions.returnOrder(orderId, returnOrderData, language));
    },
    getOrder: id => {
        dispatch(actions.get(id));
    },
    getReturnReasons: () => {
        dispatch(miscActions.getReturnReasons());
    },
    returnOrderCalculate: (function () {
        let _id;
        let _returnOrderCalculateData;

        let _returnOrderCalculate = _.debounce(() => {
            dispatch(actions.returnOrderCalculate(_id, _returnOrderCalculateData));
        }, 500);

        return (id, returnOrderCalculateData) => {
            _id = id;
            _returnOrderCalculateData = returnOrderCalculateData;

            _returnOrderCalculate();
        };
    })(),
    returnOrderCalculateInstant: (id, returnOrderCalculateData) => {
        dispatch(actions.returnOrderCalculate(id, returnOrderCalculateData));
    },
    returnOrderCalculateReset: () => {
        dispatch(actions.returnOrderCalculateReset());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnOrderItemsWindow);
